import { render, staticRenderFns } from "./GasbotFaq.vue?vue&type=template&id=b9ee88e4&scoped=true"
import script from "./GasbotFaq.vue?vue&type=script&lang=ts"
export * from "./GasbotFaq.vue?vue&type=script&lang=ts"
import style0 from "./GasbotFaq.vue?vue&type=style&index=0&id=b9ee88e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee88e4",
  null
  
)

export default component.exports